import React from "react";
import Icon from "./Icon";

const APIMaintenance = ({ line1, line2 }) => {
  return (
    <div className="u-center">
      <Icon name="circleExclamation" width={44} height={44} />
      <p className="f-h4 c-purple u-mt1 u-mb1" style={{ margin: "0 auto" }}>
        {line1}
      </p>
      <p className="c-purple">{line2}</p>
    </div>
  );
};

export default APIMaintenance;
